"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSemverSuffix = exports.isSemver = exports.buildSegmentModel = exports.buildSegmentRuleModel = exports.buildSegmentConditionModel = void 0;
var util_1 = require("../features/util");
var models_1 = require("./models");
function buildSegmentConditionModel(segmentConditionJSON) {
    return new models_1.SegmentConditionModel(segmentConditionJSON.operator, segmentConditionJSON.value, segmentConditionJSON.property_);
}
exports.buildSegmentConditionModel = buildSegmentConditionModel;
function buildSegmentRuleModel(ruleModelJSON) {
    var ruleModel = new models_1.SegmentRuleModel(ruleModelJSON.type);
    ruleModel.rules = ruleModelJSON.rules.map(function (r) { return buildSegmentRuleModel(r); });
    ruleModel.conditions = ruleModelJSON.conditions.map(function (c) { return buildSegmentConditionModel(c); });
    return ruleModel;
}
exports.buildSegmentRuleModel = buildSegmentRuleModel;
function buildSegmentModel(segmentModelJSON) {
    var model = new models_1.SegmentModel(segmentModelJSON.id, segmentModelJSON.name);
    model.featureStates = segmentModelJSON['feature_states'].map(function (fs) {
        return (0, util_1.buildFeatureStateModel)(fs);
    });
    model.rules = segmentModelJSON['rules'].map(function (r) { return buildSegmentRuleModel(r); });
    return model;
}
exports.buildSegmentModel = buildSegmentModel;
function isSemver(value) {
    return typeof value == 'string' && value.endsWith(':semver');
}
exports.isSemver = isSemver;
function removeSemverSuffix(value) {
    return value.replace(':semver', '');
}
exports.removeSemverSuffix = removeSemverSuffix;
